module.exports = __webpack_public_path__ + "static/media/csharp.e17d5df5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/csharp.jpg
 ** module id = 1243
 ** module chunks = 0
 **/